import { mixed, object } from 'yup'
import { areWallsAdjacent, areWallsSameCartesianDirection, isCartesianOriented } from './utils'

export const mergeWallSchema = object({
  wall1: mixed<ShapeObject>()
    .required('Wand 1 ist erforderlich')
    .test({
      name: 'wall1-cartesian',
      message: 'Wand 1 muss kartesisch orientiert sein (horizontal oder vertikal)',
      test: function (wall1) {
        if (!wall1) return false
        return isCartesianOriented(wall1 as ShapeObject)
      },
    }),
  wall2: mixed<ShapeObject>()
    .required('Wand 2 ist erforderlich')
    .test({
      name: 'wall2-cartesian',
      message: 'Wand 2 muss kartesisch orientiert sein (horizontal oder vertikal)',
      test: function (wall2) {
        if (!wall2) return false
        return isCartesianOriented(wall2 as ShapeObject)
      },
    })
    .test({
      name: 'walls-adjacent',
      message:
        'Die Wände müssen benachbart sein (eine Wand muss an einem Punkt der anderen Wand beginnen oder enden)',
      test: function (wall2) {
        const { wall1 } = this.parent
        if (!wall1 || !wall2) return false
        return areWallsAdjacent(wall1 as ShapeObject, wall2 as ShapeObject)
      },
    })
    .test({
      name: 'walls-same-storey',
      message: 'Die Wände müssen im gleichen Stockwerk sein',
      test: function (wall2) {
        const { wall1 } = this.parent
        if (!wall1 || !wall2) return false
        return wall1.storey === wall2.storey
      },
    })
    .test({
      name: 'walls-same-cartesian-direction',
      message:
        'Die Wände müssen in die gleiche kartesische Richtung orientiert sein (beide horizontal oder beide vertikal)',
      test: function (wall2) {
        const { wall1 } = this.parent
        if (!wall1 || !wall2) return false
        return areWallsSameCartesianDirection(wall1 as ShapeObject, wall2 as ShapeObject)
      },
    }),
})
